import { DispatchReport } from "../../../../../core";

export const dispatchReport = {
  classValidation: (row: any) => {
    if (row.stateName === "Cancelado" || row.stateName === "CANCELADO") {
      return "pending";
    }
    return '';
  },

  searchText: "",
  sort: true,
  dialogHability: true,
  filter: false,
  alterColumns: true,
  paginator: true,
  checkbox: false,
  export: true,
  exportAdditional: false,
  exportAllData: true,
  exportFile: "reporte_despacho.xlsx",
  exportNameAdditional: "Exportar Cancelados",
  exportFileAdditional: "reporte_cancelado.xlsx",
  expandable: false,
  disabled: false,
  partialField: "",
  columns: [
    {
      title: "Entidad actual",
      name: "currentEntityName",
      type: "string",
      visible: true,
      mandatory: true,
      class: "center",
      value: (element: DispatchReport) => element.currentEntityName,
    },
    {
      title: "Estado de despacho",
      name: "stateName",
      type: "string",
      visible: true,
      mandatory: true,
      class: "center",
      value: (element: DispatchReport) => element.stateName,
    },
    {
      title: 'Estado de retiro',
      name: 'stateWithdraw',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      mandatory: true,
      class: 'center',
      value: (element: DispatchReport) => element.withdrawStatus
    },
    {
      title: 'Fecha de entrega de NV',
      name: 'deliveryNvDate',
      type: 'string',
      visible: true,
      class: "center dateInfo",
      value: (element: DispatchReport) => element.deliveryDate,
    },
    {
      title: "Fecha original de entrega",
      name: "deliveryOriginalDate",
      type: "string",
      visible: true,
      class: "center dateInfo",
      value: (element: DispatchReport) =>
        element.originalDeliveryDate
          ? element.originalDeliveryDate.substring(0, 10)
          : element.deliveryDate
            ? element.deliveryDate.substring(0, 10)
            : "",
    },
    {
      title: "Tipo de origen",
      name: "originType",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.originType,
    },
    {
      title: "Entidad de origen stock",
      name: "originEntity",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.originEntity,
    },
    {
      title: "Entidad de venta",
      name: "saleLocationName",
      type: "string",
      mandatory: true,
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.saleLocationName,
    },
    {
      title: "Entidad final de ruta",
      name: "deliveryEntity",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.deliveryEntity,
    },
    {
      title: "Ruta",
      name: "route",
      type: "string",
      expand: "expand-column",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.route,
    },
    {
      title: "Código de N/V",
      name: "saleNoteId",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.saleNoteId,
    },
    {
      title: "Código de despacho",
      name: "dispatchId",
      type: "string",
      visible: true,
      class: "center dispatchCode",
      value: (element: DispatchReport) => element.dispatchId,
    },
    {
      title: "SKU",
      name: "skuCode",
      type: "string",
      mandatory: true,
      visible: true,
      class: "center skuCode",
      value: (element: DispatchReport) =>
        element.skuCode +
        (element.skuPartialSequence
          ? "-" + element.skuPartialSequence.toString()
          : ""),
    },
    {
      title: "Peso de producto",
      name: "weigth",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.weight,
    },
    {
      title: "Volumen de producto",
      name: "volumen",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.volume,
    },
    {
      title: "Tamaño",
      name: "productSize",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.productSize,
    },
    {
      title: "LPN",
      name: "lpn",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.lpn,
    },
    {
      title: "Descripción",
      name: "productDescription",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.skuName.replace("�", ""),
    },
    {
      title: "División de producto",
      name: "productDivision",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.divisionDescription,
    },
    {
      title: "Área de producto",
      name: "productArea",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.areaDescription,
    },
    {
      title: "Departamento de producto",
      name: "productDepartment",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.departmentDescription,
    },
    {
      title: "Línea de producto",
      name: "productLine",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.lineDescription,
    },
    {
      title: "Cantidad total",
      name: "amount",
      type: "string",
      visible: true,
      mandatory: true,
      class: "center",
      value: (element: DispatchReport) => element.totalAmount,
    },
    {
      title: "Cantidad entregada",
      name: "processedAmount",
      type: "string",
      visible: true,
      mandatory: true,
      class: "center",
      value: (element: DispatchReport) => element.processedAmount,
    },
    {
      title: "Cantidad pendiente",
      name: "pendingAmount",
      type: "string",
      visible: true,
      mandatory: true,
      class: "center",
      value: (element: DispatchReport) => element.pendingAmount,
    },
    {
      title: "Cantidad cancelada",
      name: "canceled",
      type: "string",
      visible: true,
      mandatory: true,
      class: "center",
      value: (element: DispatchReport) => element.canceledAmount,
    },
    {
      title: "Fecha de venta",
      name: "saleDate",
      type: "string",
      visible: true,
      class: "dispatch-report-saleDate center",
      value: (element: DispatchReport) => element.saleDate,
    },
    {
      title: "Fecha VTEX",
      name: "deliveryDate",
      type: "string",
      visible: true,
      class: "dispatch-report-deliveryDate center",
      value: (element: DispatchReport) => element.deliveryDate,
    },
    /* {
      title: 'Fecha planificada de estado',
      name: 'plannedDate',
      type: 'string',
      class: 'dispatch-report-saleDate center',
      value: (element: DispatchReport) => element.plannedDate
    }, */
    {
      title: "Fecha real de entrega",
      name: "realDispatchDate",
      type: "string",
      visible: true,
      class: "dispatch-report-dispatchDate center",
      value: (element: DispatchReport) => element.dispatchDate,
    },
    {
      title: "Fecha de recepción entidad final",
      name: "orderArrivalDate",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.receptionDate,
    },
    {
      title: "Documento del cliente",
      name: "customerDocument",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.customerDocumentNumber,
    },
    {
      title: "Documento persona que retira",
      name: "withdrawPersonDocument",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) =>
        element.withdrawPersonDocument,
    },
    {
      title: "Telf. cliente",
      name: "contactPhone",
      type: "string",
      visible: true,
      class: "left",
      value: (element: DispatchReport) => element.contactPhone,
    },
    {
      title: "Nombre de cliente",
      name: "customerName",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) =>
        element.firstName + " " + element.lastName,
    },
    {
      title: "Nombre de persona que retira",
      name: "withdrawPerson",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) =>
        element.withdrawPerson,
    },
    {    
      title: "Correo cliente",
      name: "contactEmail",
      type: "string",
      visible: true,
      class: "left",
      value: (element: DispatchReport) => element.contactEmail,
    },
    {
      title: "Departamento",
      name: "department",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.department,
    },
    {
      title: "Provincia",
      name: "province",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.province,
    },
    {
      title: "Distrito",
      name: "district",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.district,
    },
    {
      title: "Dirección de entrega",
      name: "deliveryAddress",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.deliveryAddress,
    },
    {
      title: "Zona de entrega",
      name: "deliveryZone",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.zoneName,
    },
    {
      title: "Modalidad de despacho",
      name: "deliveryMode",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.dispatchTypeName,
    },
    {
      title: "OC",
      name: "oc",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.purchaseOrderNumber,
    },
    {
      title: "Código Vtex",
      name: "ecommerceId",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.ecommerceId,
    },
    {
      title: "Usuario de Venta",
      name: "saleUser",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.saleUser,
    },
    {
      title: "Código de viaje",
      name: "dispatchTripId",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.dispatchTripId,
    },
    {
      title: "Estado del viaje",
      name: "stateTrip",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.stateTrip,
    },
    {
      title: "Tipo de viaje",
      name: "tripType",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.tripType,
    },
    {
      title: "Fecha creación viaje",
      name: "createdDateTrip",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.createdDateTrip,
    },
    {
      title: "Fecha envío viaje",
      name: "tripShippingDate",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.tripShippingDate,
    },
    {
      title: "Fecha de recojo",
      name: "generatedPmmAt",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.generatedPmmAt,
    },
    {
      title: "Fecha de internamiento",
      name: "generatedInternmentAt",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.generatedInternmentAt,
    },
    {
      title: "Nro. de intentos de despacho",
      name: "attemptsDelivery",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.attemptsDelivery,
    },
    {
      title: "Número de guía",
      name: "guideNumber",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.guideNumber,
    },
    {
      title: "Sistema de creación",
      name: "originTrip",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.originTrip,
    },
    {
      title: "Código de carga",
      name: "chargeNumber",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.chargeNumber,
    },
    {
      title: "RUC transportista",
      name: "rucCarrier",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.rucCarrier,
    },
    {
      title: "Razón transportista",
      name: "idCurrier",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.businessNameCarrier,
    },
    {
      title: "Entidad de viaje",
      name: "entityTrip",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.entityTrip,
    },
    {
      title: "Motivo de Pre cancelación",
      name: "preCancellationReason",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.preCancellationReason,
    },
    {
      title: "Fecha de Pre cancelación",
      name: "orderPrecancelledDate",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.orderPrecancelledDate,
    },
    {
      title: "Fecha de Cancelación",
      name: "cancellationDate",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.cancellationDate,
    },
    {
      title: "Estado de Pago",
      name: "paymentState",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.paymentState,
    },
    {
      title: "Fecha de Pago",
      name: "paymentDate",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.paymentDate,
    },
    {
      title: "Medio de pago",
      name: "paymentMethod",
      type: "string",
      visible: true,
      class: "left",
      value: (element: DispatchReport) => element.paymentMethod,
    },

    {
      title: "Número de cotización",
      name: "quotationNumber",
      type: "string",
      visible: true,
      class: "left",
      value: (element: DispatchReport) => element.quotationNumber,
    },
    {
      title: "Canal de venta",
      name: "channel",
      type: "string",
      visible: true,
      class: "left",
      value: (element: DispatchReport) => element.channel,
    },
    {
      title: "Ubicación",
      name: "location",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.location,
    },
    {
      title: "Tipo de mercaderia",
      name: "typeOfMerchandise",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.division,
    },
    {
      title: "Tipo de despacho",
      name: "deliveryAgreement",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.deliveryAgreement,
    },
    {
      title: "Compañía origen",
      name: "originalCompanyCode",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.originalCompanyCode,
    },
    {
      title: "Usuario de entrega",
      name: "deliveryRecordUser",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.deliveryRecordUser,
    },
    {
      title: "Fecha transacción de entrega",
      name: "deliveryTransactionDate",
      type: "string",
      visible: true,
      class: "center dateInfo",
      value: (element: DispatchReport) =>
        element && element.deliveryTransactionDate
          ? element.deliveryTransactionDate.substring(0, 10)
          : "",
    },
    {
      title: "Fecha de picking",
      name: "pickingConsolidatedDate",
      type: "string",
      visible: true,
      class: "center dateInfo",
      value: (element: DispatchReport) =>
        element && element.pickingConsolidatedDate
          ? element.pickingConsolidatedDate.substring(0, 10)
          : "",
    },
    {
      title: "Fecha de entrega por tracking",
      name: "trackingDeliveryDate",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.trackingDeliveryDate,
    },
    {
      title: "Inicio de ventana horaria",
      name: "startDeliveryWindow",
      type: "string",
      visible: true,
      class: "center dateInfo",
      value: (element: DispatchReport) => element.startDeliveryWindow,
    },
    {
      title: "Fin de ventana horaria",
      name: "endDeliveryWindow",
      type: "string",
      visible: true,
      class: "center dateInfo",
      value: (element: DispatchReport) => element.endDeliveryWindow,
    },
    //REPORTE DE DESPACHOS - RETIRO EN TIENDA Y DESPACHO A DOMICILIO
    {
      title: "Cumplimiento ​de Entrega",
      name: "deliveryCompliance",
      type: "string",
      visible: true,
      class: "center dateInfo",
      value: (element: DispatchReport) => element.deliveryCompliance,
    },
    {
      title: "Cumplimiento ​InFull",
      name: "inFullCompliance ",
      type: "string",
      visible: true,
      class: "center dateInfo",
      value: (element: DispatchReport) => element.inFullCompliance,
    },

    {
      title: "Cumplimiento ​de Arribo",
      name: "arrivalCompliance",
      type: "string",
      visible: true,
      class: "center dateInfo",
      value: (element: DispatchReport) => element.arrivalCompliance,
    },
    {
      title: "Cumplimiento ​de Ubicación",
      name: "locationCompliance",
      type: "string",
      visible: true,
      class: "center dateInfo",
      value: (element: DispatchReport) => element.locationCompliance,
    },
    {
      title: "Fecha máxima de carga",
      name: "pickingDate",
      type: "string",
      visible: true,
      class: "center dateInfo",
      value: (element: DispatchReport) =>
        element && element.pickingDate
          ? element.pickingDate.substring(0, 10)
          : "",
    },
    {
      title: "Pallet",
      name: "palletNbr",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.palletNbr,
    },
    {
      title: "Referencia",
      name: "reference",
      type: "string",
      visible: true,
      class: "center",
      value: (element: DispatchReport) => element.reference,
    },
    {
      title: 'Agrupación de entidad inicial',
      name: 'originGroupName',
      type: 'string',
      visible: true,
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchReport) => element.originGroupName
    },
    {
      title: 'Agrupación de entidad actual',
      name: 'groupName',
      type: 'string',
      visible: true,
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchReport) => element.groupName
    },
    {
      title: 'Agrupación de entidad siguiente',
      name: 'nextGroupName',
      type: 'string',
      visible: true,
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchReport) => element.nextGroupName
    },
    {
      title: 'Agrupación de entidad final',
      name: 'finalGroupName',
      type: 'string',
      visible: true,
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchReport) => element.finalGroupName
    },
    {

      title: 'Latitud',
      name: 'latitude',
      type: 'string',
      visible: true,
      class: 'center',
      value: (element: DispatchReport) => element.geoLocalization && element.geoLocalization !== '' ? element.geoLocalization.split(",")[0] : ""
    },
    {
      title: 'Longitud',
      name: 'longitude',
      type: 'string',
      visible: true,
      class: 'center',
      value: (element: DispatchReport) => element.geoLocalization && element.geoLocalization !== '' ? element.geoLocalization.split(",")[1] : ""
    },
    {
      title: "",
      name: "stateDispatch",
      type: "editableColumns",
      visible: true,
      editable: true,
      checkAll: true,
      class: "width-none",
      value: () => "",
    },
  ]
};
